var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    { attrs: { toggleable: "lg", type: "", variant: "faded" } },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("b-navbar-brand", { attrs: { to: "/", title: _vm.data.name } }, [
            _c("img", {
              staticClass: "brand-logo",
              attrs: { src: _vm.app_logo, alt: _vm.data.name },
            }),
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", {
            attrs: { target: "nav-collapse" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ expanded }) {
                  return [
                    expanded
                      ? _c("b-icon", { attrs: { icon: "chevron-bar-up" } })
                      : _c("b-icon", { attrs: { icon: "chevron-bar-down" } }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _vm.loggedInUser
                ? _c(
                    "b-navbar-nav",
                    { staticClass: "text-center" },
                    [
                      !_vm.loggedInUser.is_staff
                        ? _c(
                            "b-nav-item",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    to: "/santri",
                                    role: "button",
                                    title: "Santri",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-users" }),
                                  _vm._v(" Santri\n          "),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.loggedInUser.is_staff
                        ? _c(
                            "b-nav-item",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    to: "/santri/absensi",
                                    role: "button",
                                    title: "Absensi",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-calendar-check",
                                  }),
                                  _vm._v(" Absensi\n          "),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/ppob?token=" + _vm.token,
                                role: "button",
                                title: "PPOB",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-mobile" }),
                              _vm._v(" PPOB\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/jadwal-shalat",
                                role: "button",
                                title: "Jadwal Shalat",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-clock" }),
                              _vm._v(" Jadwal Shalat\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/hadits",
                                role: "button",
                                title: "Hadits",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-book" }),
                              _vm._v(" Hadits\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/al-quran",
                                role: "button",
                                title: "Al-Quran",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-book-open" }),
                              _vm._v(" Al-Quran\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/surat-pendek",
                                role: "button",
                                title: "Surat Pendek",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-book-open" }),
                              _vm._v(" Surat Pendek\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.loggedInUser.is_staff
                        ? _c(
                            "b-nav-item",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    to: "/admin/home",
                                    role: "button",
                                    title: "Dashboard",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-tachometer-alt",
                                  }),
                                  _vm._v(" Dashboard\n          "),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "b-navbar-nav",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: "/", title: "home" },
                            },
                            [
                              _c("i", { staticClass: "fa fa-home" }),
                              _vm._v(" Home"),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/jadwal-shalat",
                                role: "button",
                                title: "Jadwal Shalat",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-clock" }),
                              _vm._v(" Jadwal Shalat\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/hadits",
                                role: "button",
                                title: "Hadits",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-book" }),
                              _vm._v(" Hadits\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/al-quran",
                                role: "button",
                                title: "Al-Quran",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-book-open" }),
                              _vm._v(" Al-Quran\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/page/surat-pendek",
                                role: "button",
                                title: "Surat Pendek",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-book-open" }),
                              _vm._v(" Surat Pendek\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/auth/login",
                                role: "button",
                                title: "Login",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-sign-in-alt" }),
                              _vm._v(" Masuk\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _vm.loggedInUser
                    ? _c(
                        "b-nav-item",
                        {
                          attrs: { title: "Instagram", target: "_blank" },
                          on: { click: _vm.logout },
                        },
                        [
                          _c("i", { staticClass: "fa fa-sign-out-alt" }),
                          _vm._v(" Keluar\n        "),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }